import styled from "styled-components";

export const Wrap = styled.div`
  padding: 0 16px;
`;

export const Row = styled.div<{ $applied?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${(p) => (p.$applied ? "#eaf5ff" : "#ffedd1")};
  border-radius: 16px;
  padding: 13px 8px;
  gap: 4px;
  border: ${(p) => (p.$applied ? "1px solid #008cff" : "none")};
`;

export const Icon = styled.img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  line-height: normal;
`;

export const Cta = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const InfoIcon = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #757575;
`;
